class PredictiveSearch extends HTMLElement {

  constructor() {

    super();

    this.input = this.querySelector('input[type="search"]');

    this.predictiveSearchResults = this.querySelector('#predictive-search');

    

    this.input.addEventListener('input', this.debounce((event) => {

      this.onChange(event);

    }, 300).bind(this));



    this.input.addEventListener('focus', this.onFocus.bind(this));

    // Close when clicking outside

    document.addEventListener('click', (event) => {

       if (!this.contains(event.target)) this.close();

    });

  }



  onChange() {

    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {

      this.close();

      return;

    }

    this.getSearchResults(searchTerm);

  }



  onFocus() {

    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) return;



    if (this.getAttribute('results') === 'true') {

      this.open();

    } else {

      this.getSearchResults(searchTerm);

    }

  }



  getSearchResults(searchTerm) {

    const queryKey = searchTerm.replace(" ", "-").toLowerCase();

    this.setLiveRegionLoadingState();



    if (this.cachedResults && this.cachedResults[queryKey]) {

      this.renderSearchResults(this.cachedResults[queryKey]);

      return;

    }



    fetch(`${window.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`)

      .then((response) => {

        if (!response.ok) {

          var error = new Error(response.statusText);

          this.close();

          throw error;

        }

        return response.text();

      })

      .then((text) => {

        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;

        this.cachedResults = {};

        this.cachedResults[queryKey] = resultsMarkup;

        this.renderSearchResults(resultsMarkup);

      })

      .catch((error) => {

        this.close();

        throw error;

      });

  }



  setLiveRegionLoadingState() {

    this.setAttribute('loading', true);

  }



  renderSearchResults(resultsMarkup) {

    this.predictiveSearchResults.innerHTML = resultsMarkup;

    this.setAttribute('results', true);



    this.setLiveRegionResults();

    this.open();

  }



  setLiveRegionResults() {

    this.removeAttribute('loading');

    this.setAttribute('open', true);

  }



  open() {

    this.predictiveSearchResults.style.display = 'block';

  }



  close() {

    this.predictiveSearchResults.style.display = 'none';

    this.removeAttribute('results');

    this.removeAttribute('loading');

  }



  debounce(fn, wait) {

    let t;

    return (...args) => {

      clearTimeout(t);

      t = setTimeout(() => fn.apply(this, args), wait);

    };

  }

}



customElements.define('predictive-search', PredictiveSearch);

